import {jsx as _jsx} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import useRouter from '~/hooks/useRouter'
import defaultOrgAvatar from '~/styles/theme/images/avatar-organization.svg'
import NotificationAction from './NotificationAction'
import NotificationTemplate from './NotificationTemplate'




const PromoteToBillingLeader = (props) => {
  const {notification: notificationRef} = props
  const notification = useFragment(
    graphql`
      fragment PromoteToBillingLeader_notification on NotifyPromoteToOrgLeader {
        ...NotificationTemplate_notification
        id
        organization {
          id
          name
          picture
        }
      }
    `,
    notificationRef
  )
  const {history} = useRouter()
  const {organization} = notification
  const {name: orgName, id: orgId, picture: orgPicture} = organization

  const goToOrg = () => {
    history.push(`/me/organizations/${orgId}`)
  }

  return (
    _jsx(NotificationTemplate, {
      avatar: orgPicture || defaultOrgAvatar,
      message: `You‘ve been promoted to billing leader for ${orgName}`,
      action: _jsx(NotificationAction, { label: 'See organization', onClick: goToOrg,} ),
      notification: notification,}
    )
  )
}

export default PromoteToBillingLeader
